import { TipoRegistroInstrumentoFinanceiro } from 'common/genericTypes';
import { typedAction } from 'store/modules/base';
import { CoordenadoresAction, coordenadoresInitialState, CoordenadoresState } from './coordenadores';

interface IStateCoordenadores {
  coordenadores: CoordenadoresState;
}

export const typeOfRegister = (payload: TipoRegistroInstrumentoFinanceiro) => {
  return typedAction('coordenadores/TYPE_OF_REGISTER', payload);
};

export const highlightErrors = (payload: boolean) => {
  return typedAction('coordenadores/HIGHLIGHT_ERRORS', payload);
};

export function coordenadoresReducer(
  state: IStateCoordenadores = {
    coordenadores: coordenadoresInitialState,
  },
  action: CoordenadoresAction
): IStateCoordenadores {
  switch (action.type) {
    case 'coordenadores/UPDATEFIELD':
      return { ...state, coordenadores: { ...state.coordenadores, [action.payload.name]: action.payload.value } };
    case 'coordenadores/UPDATE':
      return { ...state, coordenadores: action.payload };
    case 'coordenadores/RESET':
      return { ...state, coordenadores: coordenadoresInitialState };
    default:
      return state;
  }
}


export default coordenadoresReducer;
